import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        public router: Router,
    ) {}

    // canActivate() {
    //     return this.authService.isAuthenticated;
    // }

    canActivate(): boolean {
        if (!this.authService.isAuthenticated) {
          this.router.navigate(['auth/login']);
          return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/auth-guard.service.ts